
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><em parentName="h3">{`[Deprecated]`}</em>{` `}<inlineCode parentName="h3">{`injectGlobal`}</inlineCode></h3>
    <blockquote>
      <p parentName="blockquote">{`The `}<inlineCode parentName="p">{`injectGlobal`}</inlineCode>{` API was removed and replaced by `}<inlineCode parentName="p">{`createGlobalStyle`}</inlineCode>{` in styled-components v4.`}</p>
    </blockquote>
    <p>{`A helper method to write global CSS. It does not return a component, but adds the styles to
the stylesheet directly.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">TaggedTemplateLiteral</Code>
    </Column>
    <Column mdxType="Column">A tagged template literal with your global styles inside.</Column>
  </Row>
    </Table>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { injectGlobal } from 'styled-components'

injectGlobal\`
  @font-face {
    font-family: "Operator Mono";
    src: url("../fonts/Operator-Mono.ttf");
  }

  body {
    margin: 0;
  }
\`
`}</code></pre>
    <p>{`We do not encourage the use of this. Try to use it once per app at most, if you
must, contained in a single file. This is an escape hatch. Only use it for the
rare `}<inlineCode parentName="p">{`@font-face`}</inlineCode>{` definition or body styling.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;